<p-card class="flex flex-col w-full">
  <form [formGroup]="buildForm" (ngSubmit)="onGuardar()" enctype="multipart/form-data" class="space-y-2">

    <p-fieldset legend="Descripción de la Solicitud" [toggleable]="false"
      styleClass="mb-4 legend-right  border-round-md border-1 border-surface-300 shadow-1">
      <div class="grid grid-cols-12 md:grid-cols-12 lg:grid-cols-12 xl:grid-cols-12 gap-2">
        <div class="col-span-12 md:col-span-4 lg:col-span-4 xl:col-span-4">
          <label for="CodGlobal" class="label-global">Empresas *</label>
          <p-select [options]="initialService.EmpresaExternoOptions" optionLabel="name" optionValue="code"
            formControlName="CodGlobal" placeholder="Seleccione" [panelStyle]="{ 'background-color': isDarkMode ? '#1f2937' : '#ffffff', 'color': isDarkMode ? '#ffffff' : '#000000',
    'opacity': '1' }" class="w-full border Seleccionerounded px-2 py-1"></p-select>
        </div>
        <div class="col-span-12 md:col-span-4 lg:col-span-4 xl:col-span-4">
          <label for="CodTipoPqr" class="label-global">Tipo de Petición *</label>
          <p-select [options]="initialService.TipoPqrOptions" optionLabel="name" optionValue="code"
            formControlName="CodTipoPqr" placeholder="Seleccione" [panelStyle]="{ 'background-color': isDarkMode ? '#1f2937' : '#ffffff', 'color': isDarkMode ? '#ffffff' : '#000000',
    'opacity': '1' }" class="w-full border Seleccionerounded px-2 py-1"></p-select>
        </div>
        <div class="col-span-12 md:col-span-4 lg:col-span-4 xl:col-span-4">
          <label for="NumeroDocumento" class="label-global">Numero Identificacion</label>
          <input pInputText formControlName="NumeroDocumento" readonly class="w-full" />
        </div>
        <div class="col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-12">
          <label for="Asunto" class="label-global">Asunto</label>
          <div class="w-full flex">
            <input pInputText type="text" formControlName="Asunto" placeholder="Asunto"
              class="w-full border rounded px-2 py-1 disabled:bg-gray-100 disabled:text-color-500 disabled:cursor-not-allowed" />
            @if(buildForm.get('Asunto')?.invalid &&
            (buildForm.get('Asunto')?.touched ||
            buildForm.get('Asunto')?.dirty)) {
            <small
              class="text-red-500 font-medium block mt-1 bg-red-50 px-2 py-1 rounded text-xs border-l-4 border-red-500">
              {{ formService.getErrorMessage("Asunto") }}
            </small>
            }
          </div>
        </div>
        <div class="col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-12">
          <label for="Descripcion" class="label-global">Descripción</label>
          <textarea pInputTextarea formControlName="Descripcion" rows="3"
            class="w-full border border-surface-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 resize-none"
            placeholder="Ingrese un texto corto para la Descripcion"></textarea>
          @if(buildForm.get('Descripcion')?.invalid && buildForm.get('Descripcion')?.touched) {
          <small
            class="text-red-500 font-medium block mt-1 bg-red-50 px-2 py-1 rounded text-xs border-l-4 border-red-500">
            {{ formService.getErrorMessage("Descripcion") }}
          </small>
          }
        </div>
      </div>
    </p-fieldset>
    <p-fieldset legend="Adjuntos" [toggleable]="false"
      styleClass="mb-4 legend-right  border-round-md border-1 border-surface-300 shadow-1">
      <div class="grid grid-cols-12 md:grid-cols-12 lg:grid-cols-12 xl:grid-cols-12 gap-2">
        <div class="col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-12">
          <label for="fileBase64DocPqr" class="label-global">
            Adjuntar Archivo
          </label>
          <input pInputText type="file" (change)="onFileChange($event)" class="w-full" />
          @if (buildForm.get('fileBase64DocPqr')?.invalid && (buildForm.get('fileBase64DocPqr')?.touched ||
          buildForm.get('fileBase64DocPqr')?.dirty)) {
          <small
            class="text-red-500 font-medium block mt-1 bg-red-50 px-2 py-1 rounded text-xs border-l-4 border-red-500">
            {{ formService.getErrorMessage("fileBase64DocPqr") }}
          </small>
          }
        </div>
        <div class="col-span-12">
          <div class="p-3 border border-surface-300 rounded-md">
            <p class="text-xs leading-5 mb-2">
              <strong class="text-xs">Autorización para el Tratamiento de Datos Personales:</strong><br>
              Al enviar esta información, Autorizo de manera previa, expresa e
              informada el tratamiento de mis datos personales conforme a la Ley 1581
              de 2012 y las políticas de protección de datos de la entidad. Declaro
              que he sido informado sobre las finalidades, derechos y mecanismos de
              consulta o supresión de mis datos.
            </p>

            <div class="flex items-center gap-2 mt-2">
              <p-checkbox formControlName="AutorizoDatos" [binary]="true" inputId="AutorizoDatos"></p-checkbox>
              <label class="cursor-pointer text-xs" for="AutorizoDatos">
                Acepto la autorización del tratamiento de mis datos personales
              </label>
            </div>

            @if (buildForm.get('AutorizoDatos')?.invalid &&
            (buildForm.get('AutorizoDatos')?.touched || buildForm.get('AutorizoDatos')?.dirty)) {
            <small
              class="text-red-500 font-medium block mt-1 bg-red-50 px-2 py-1 rounded text-xs border-l-4 border-red-500">
              Debe aceptar la autorización para continuar.
            </small>
            }
          </div>
        </div>
      </div>
    </p-fieldset>
    <div class="w-full flex justify-end mt-4 gap-3">

      <p-button label="Guardar" variant="outlined" icon="pi pi-check" [loading]="loading" [disabled]="loading || buildForm.invalid" (click)="onGuardar()"
        class="px-4 py-2 border-round-lg">
      </p-button>

      <p-button label="Cancelar" variant="outlined" icon="pi pi-times" severity="danger" (click)="onCancelar()"
        class="px-4 py-2 border-round-lg">
      </p-button>

    </div>